export default __webpack_public_path__ + "static/media/investors-others.d8afac8c.wav";